import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/gallery/CLEVRLOGO.png';
import { trackPhoneClick } from '../../utils/analytics';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    setIsMenuOpen(false);
    
    // If we're not on the home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
    } else {
      // If we're on home page, scroll to section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handlePhoneClick = () => {
    trackPhoneClick('+94774641111');
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src={logo} alt="CLEVR Logo" className="logo-img" />
        </Link>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul className="nav-list">
            <li><a href="#home" onClick={(e) => handleNavClick(e, 'home')} className="nav-link">Home</a></li>
            <li><Link to="/solutions" className="nav-link" onClick={() => setIsMenuOpen(false)}>Solutions</Link></li>
            <li><Link to="/clevr-studio" className="nav-link" onClick={() => setIsMenuOpen(false)}>Studio</Link></li>
            <li><Link to="/projects" className="nav-link" onClick={() => setIsMenuOpen(false)}>Projects</Link></li>
            <li><a href="#benefits" onClick={(e) => handleNavClick(e, 'benefits')} className="nav-link">Benefits</a></li>
            <li><a href="#process" onClick={(e) => handleNavClick(e, 'process')} className="nav-link">Process</a></li>
            <li><a href="#products" onClick={(e) => handleNavClick(e, 'products')} className="nav-link">Products</a></li>
            <li><a href="#testimonials" onClick={(e) => handleNavClick(e, 'testimonials')} className="nav-link">Testimonials</a></li>
            <li><a href="#faqs" onClick={(e) => handleNavClick(e, 'faqs')} className="nav-link">FAQs</a></li>
          </ul>
        </nav>

        <a href="https://wa.me/+94774641111" className="header-btn">
          Book a free consultation
        </a>

        <button 
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
